import { IOrganizationStore } from './types';

const initStore: IOrganizationStore = {
  current: null,
  list: [],
};

export default initStore;
